function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import fecha from 'fecha';
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import Badge from "./Badge";
import Button from "./Button";
import CardHeader from "./CardHeader";
import CardTitle from "./CardTitle"; // TODO extract to date helper, i18n:

var format = function format(date, dateFormat) {
  return fecha.format(date, dateFormat);
};

var timezone = function timezone(date) {
  return date.toLocaleTimeString('en-us', {
    timeZoneName: 'short'
  }).split(' ')[2];
};

var defaultProps = {
  dateFormat: 'ddd MMM DD YYYY HH:mm:ss'
};

var NoteHeader = function NoteHeader(_ref) {
  var _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? defaultProps.dateFormat : _ref$dateFormat,
      props = _objectWithoutProperties(_ref, ["dateFormat"]);

  var note = props.note,
      onDelete = props.onDelete,
      onEdit = props.onEdit,
      showTimezone = props.showTimezone;
  var date = note.date,
      edited = note.edited,
      from = note.from,
      title = note.title;
  var headerClassNames = classnames('d-flex', 'flex-wrap', 'align-items-center', 'justify-content-between', 'py-2', 'pr-2', 'bg-info');
  var anyDataExisting = date || from || title;
  return anyDataExisting ?
  /*#__PURE__*/
  React.createElement(CardHeader, {
    className: headerClassNames
  },
  /*#__PURE__*/
  React.createElement("div", {
    className: "d-inline-flex align-items-center"
  }, edited &&
  /*#__PURE__*/
  React.createElement(Badge, {
    color: "primary",
    className: "text-uppercase mr-2 js-note-header__edited"
  }, "Edited"),
  /*#__PURE__*/
  React.createElement("div", {
    className: "d-flex flex-column"
  }, title &&
  /*#__PURE__*/
  React.createElement(CardTitle, null, title), date &&
  /*#__PURE__*/
  React.createElement("span", {
    className: "m-0 my-1 mr-auto"
  },
  /*#__PURE__*/
  React.createElement("span", {
    className: "d-none d-sm-inline"
  }, edited ? 'Last edited' : 'Posted', from ?
  /*#__PURE__*/
  React.createElement("span", {
    className: "js-note-header__from"
  }, " by ".concat(from)) : ' ', " on ",
  /*#__PURE__*/
  React.createElement("span", {
    className: "js-note-header__date"
  }, format(date, dateFormat), showTimezone && " ".concat(timezone(date)))),
  /*#__PURE__*/
  React.createElement("span", {
    className: "d-sm-none"
  }, from ?
  /*#__PURE__*/
  React.createElement("span", null, from, " ") : null,
  /*#__PURE__*/
  React.createElement("span", {
    className: "js-note-header__shortDate"
  }, format(date, 'M/D/YY h:mm A'), " ", timezone(date)))))),
  /*#__PURE__*/
  React.createElement("div", {
    className: "d-inline-flex"
  }, onEdit ?
  /*#__PURE__*/
  React.createElement(Button, {
    color: "link",
    onClick: function onClick() {
      return onEdit(note);
    },
    className: "js-note-header__edit mr-3 p-0"
  }, "Edit") : null, onDelete ?
  /*#__PURE__*/
  React.createElement(Button, {
    color: "link",
    onClick: function onClick() {
      return onDelete(note);
    },
    className: "js-note-header__delete p-0"
  }, "Delete") : null)) :
  /*#__PURE__*/
  React.createElement("div", {
    className: "js-note-header__no_data"
  });
};

NoteHeader.displayName = 'NoteHeader';
NoteHeader.propTypes = {
  note: PropTypes.shape({
    date: PropTypes.instanceOf(Date),
    edited: PropTypes.bool,
    from: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  dateFormat: PropTypes.string,
  // TODO shortDateFormat ?
  showTimezone: PropTypes.bool,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func
};
NoteHeader.defaultProps = defaultProps;
export default NoteHeader;